import React from "react"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import { actualMdWidth } from "../../static/sizes/widths"
import DesktopFooter from "./components/desktop/DesktopFooter"
import License from "./components/license/License"
import MobileFooter from "./components/mobile/MobileFooter"

const Footer = () => {
  const { width } = useWindowDimensions()
  return (
    <div className="mt-auto pb-10 md:pb-0 w-full bg-igem-footer text-white md:h-[350px] lg:h-[380px] xl:h-[400px] 2xl:h-[440px]">
      {width && width >= actualMdWidth ? <DesktopFooter /> : <MobileFooter />}
      <License />
    </div>
  )
}

export default Footer
